<script>
export default {
  name: "moreFromAgent",
  data() {
    return {
      currentDate: new Date(),
      agentSuggestListing: {
        agencyLogoPath: "../../../static/img/mc-grath-logo.png",
        agencyColor: "#00011b",
        agentProfilePath: "../../../static/img/agent-1.jpg",
        isListingFavourite: false,
        listingFavouriteIconPath: "../../../static/img/heart.svg",
        listingImages: "../../../static/img/similar-search-4.jpg",
        listingAmount: "$650,000 - $670,000",
        listingAddress: "3 Park Terrace, Enfield",
        listingState: "South Australia 5085"
      }
    };
  }
};
</script>

<template>
  <el-row style="padding: 0 0 40px 0; background-color: #2D2D2D">
    <el-col :span="24">
      <el-row style="padding: 0 16px">
        <el-col :span="24" style="display: flex; justify-content: flex-start">
          <span class="more-from-agent-title">More from this agent</span>
        </el-col>
      </el-row>

      <el-row style="padding: 20px 0 40px 0">
        <el-carousel type="card">
          <el-carousel-item v-for="item in 3" :key="item">
            <el-col :span="24">
              <el-row>
                <el-col :span="24">
                  <el-card
                    :body-style="{ padding: '0px' }"
                    shadow="never"
                    style="border: 0 none; border-radius: initial"
                  >
                    <img
                      class="image"
                      src="../../assets/similar-search-1.jpg"
                      style="margin-bottom: 20px; height: 135px; width: 100%"
                    />
                    <el-col :span="24" style="padding: 10px">
                      <el-row style="margin-bottom: 20px"
                        ><span class="price-style"
                          >$650,000 - $670,000</span
                        ></el-row
                      >
                      <el-row style="margin-bottom: 10px"
                        ><span class="address-style"
                          >3 Park Terrace, Enfield</span
                        >
                      </el-row>
                      <el-row
                        ><span class="state-style"
                          >South Australia 5085</span
                        ></el-row
                      >
                    </el-col>
                  </el-card>
                </el-col>
              </el-row>
            </el-col>
          </el-carousel-item>
        </el-carousel>
      </el-row>
      <el-row style="padding: 0 16px">
        <el-col :span="24" style="display: flex; flex-direction: column">
          <el-button class="btn-view-more">View more</el-button>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style scoped>
.more-from-agent-title {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  align-self: stretch;
  font-family: Metropolis;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 117.647%;
}

.btn-view-more {
  font-feature-settings: "clig" off, "liga" off;
  justify-content: center;
  border-radius: 5px;
  border: 3px solid #ffbe00;
  background-color: #2d2d2d;
  color: #ffbe00;
  white-space: nowrap;
  text-align: center;
  padding: 14px 0;
  font: 20px Metropolis, sans-serif;
}

.price-style {
  color: #2d2d2d;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.address-style {
  color: #2d2d2d;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.state-style {
  color: #2d2d2d;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.el-carousel__item,
.el-carousel__mask {
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/propertyDetails/moreFromAgent.vue